var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesafeli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 419.89 436.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#e95066;}.cls-4{clip-path:url(#clippath-1);}.cls-5{clip-path:url(#clippath-4);}.cls-6{clip-path:url(#clippath-3);}.cls-7{clip-path:url(#clippath-2);}.cls-8{clip-path:url(#clippath-7);}.cls-9{clip-path:url(#clippath-8);}.cls-10{clip-path:url(#clippath-6);}.cls-11{clip-path:url(#clippath-5);}.cls-12{clip-path:url(#clippath-9);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 419.89,
    height: 436.52
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.12,25.26v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m142.35,25.26v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m152.58,25.26v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m162.81,25.26v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m173.04,25.26v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.27,25.26v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m193.5,25.26v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m203.73,25.26v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.96,25.26v-1.3h8.53v1.3h-8.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.73,43.49v-2.27h2.39v2.27h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m126.31,33.46l-1.77-2.86.02-.05h1.76l1.35,2.92h-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.19,43.49v-2.27h2.39v2.27h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m228.61,33.46l-1.77-2.86.02-.05h1.76l1.35,2.92h-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m237.49,43.49v-2.27h2.39v2.27h-2.39Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.82,66.86l8.2-14.61h1.55l-8.18,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m149.92,66.86l-8.18-14.61h1.55l8.2,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m165.88,63.95v-2.27h2.39v2.27h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m172.94,58.56v-1.52h8.73v1.52h-8.73Zm0,3.63v-1.52h8.73v1.52h-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.17,58.56v-1.52h8.73v1.52h-8.73Zm0,3.63v-1.52h8.73v1.52h-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m193.4,58.56v-1.52h8.73v1.52h-8.73Zm0,3.63v-1.52h8.73v1.52h-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m203.63,58.56v-1.52h8.73v1.52h-8.73Zm0,3.63v-1.52h8.73v1.52h-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.86,58.56v-1.52h8.73v1.52h-8.73Zm0,3.63v-1.52h8.73v1.52h-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.09,58.56v-1.52h8.73v1.52h-8.73Zm0,3.63v-1.52h8.73v1.52h-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m237.49,63.95v-2.27h2.39v2.27h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m252.22,66.86l-8.18-14.61h1.55l8.2,14.61h-1.57Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105,87.82v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,87.82v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m166.38,87.82v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m173.04,86.64v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.27,86.64v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m193.5,86.64v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m203.73,86.64v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.96,86.64v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.19,86.64v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m237.99,87.82v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,87.82v-15.69h1.4v15.69h-1.4Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105,108.28v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,108.28v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.27,107.1v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m193.5,107.1v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m203.73,107.1v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.96,107.1v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.19,107.1v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,108.28v-15.69h1.4v15.69h-1.4Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105,128.74v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,128.74v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m172.43,128.24l8.2-14.61h1.55l-8.18,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m223.58,128.24l8.2-14.61h1.55l-8.18,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,128.74v-15.69h1.4v15.69h-1.4Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105,149.2v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,149.2v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m162.2,148.7l8.2-14.61h1.55l-8.18,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m173.04,148.02v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.27,148.02v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m193.5,148.02v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m203.73,148.02v-1.3h8.52v1.3h-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.35,148.7l8.2-14.61h1.55l-8.18,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,149.2v-15.69h1.4v15.69h-1.4Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105,169.66v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m121.89,168.48v-1.3h8.53v1.3h-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,169.66v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,169.66v-15.69h1.4v15.69h-1.4Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105,190.12v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m111.05,189.62l8.2-14.61h1.55l-8.18,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m139.69,189.62l-8.18-14.61h1.55l8.2,14.61h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,190.12v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m155.65,186.71v-2.27h2.39v2.27h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m164.93,182.97v-1.77h4.31v1.77h-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m175.55,179.78l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Zm2.75,0l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m187.72,173.83l-2-2.25v-.05h1.88l1.69,2.3h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m197.95,173.83l-2-2.25v-.05h1.88l1.69,2.3h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m208.18,173.83l-2-2.25v-.05h1.88l1.69,2.3h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m216.47,179.78l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Zm2.75,0l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m226.31,182.97v-1.77h4.31v1.77h-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m237.49,186.71v-2.27h2.39v2.27h-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,190.12v-15.69h1.4v15.69h-1.4Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105.88,194.29l-2-2.25v-.05h1.88l1.69,2.3h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m116.11,194.29l-2-2.25v-.05h1.88l1.69,2.3h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.69,210.58v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m145.92,210.58v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.15,210.58v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m227.76,210.58v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m237.99,210.58v-15.69h1.4v15.69h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m248.22,210.58v-15.69h1.4v15.69h-1.4Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m136.54,217.6l-1.77-2.86.02-.05h1.76l1.35,2.92h-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m144.86,220.7l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Zm2.75,0l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m157,217.6l-1.77-2.86.02-.05h1.76l1.35,2.92h-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m228.61,217.6l-1.77-2.86.02-.05h1.76l1.35,2.92h-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m236.93,220.7l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Zm2.75,0l-.46-2.27v-2.51h1.67v2.51l-.46,2.27h-.75Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m150.69,424.01c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-21.03,10.99h-7.42v1.13h7.42v-1.13Zm-10.65,1.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m141.79,406.21c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-6.62,4.15l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-98.61-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-10.65,1.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91C.2,410.2,0,411.31,0,412.45s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m241.97,392.56l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19,4.05h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-19.62-5.61h-3.75v1.54h3.75v-1.54Zm-9.48-3.93l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-72.18,2.7l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-8.9,0h-3.75v1.54h3.75v-1.54Zm-75.04-5.39c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-13.88,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m350.33,375.99h-3.75v1.54h3.75v-1.54Zm-9.75,2.82h-2.08v1.97h2.08v-1.97Zm-9.61-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-9.48-3.93l-1.17-2.54h-1.53l-.02.05,1.54,2.49h1.17Zm-56.66-1.45c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.91.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-8.9,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91s.61-2.19.61-3.33-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.59-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-35.6,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15s.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-57.32-12.51c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-33.31,4.15l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19-1.56h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-20.2-9.54l-1.17-2.54h-1.53v.05s1.53,2.49,1.53,2.49h1.17Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m337.59,352.81c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.38-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-57.32-12.51c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-23.7,8.2h-2.08v1.97h2.08v-1.97Zm-34.68,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15s.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-75.12-12.51c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.68,1.19.96,1.88s.5,1.41.66,2.16c.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.34-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-67.28,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15s.59-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.55-11.05l-1.17-2.54h-1.53v.05s1.53,2.49,1.53,2.49h1.17Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m346.49,335.01c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-6.5,9.54h-7.42v1.13h7.42v-1.13Zm-20.2-9.54l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-38.86-1.45c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2-.38,1.46-.66,2.15c-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-31.68,12.5c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-10.18-2.33v-3.13h3.11v-1.32h-3.11v-3.13h-1.36v3.13h-3.11v1.32h3.11v3.13h1.36Zm-8.54-1.97h-2.08v1.97h2.08v-1.97Zm-36.31-4.05l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-7.34,1.23h-3.75v1.54h3.75v-1.54Zm-10.46-1.23l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-8.19-1.56h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-6.23,2.79h-7.42v1.13h7.42v-1.13Zm-8.9,0h-7.42v1.13h7.42v-1.13Zm-11.57-2.79h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-7.98,4.3c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-44.5,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-8.9,0c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.28.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m355.39,317.21c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-17.8,0c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-40.58,12.5c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.4,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Zm-27.62-4.3h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-26.12,3.93h-3.75v1.54h3.75v-1.54Zm-8.9,0h-3.75v1.54h3.75v-1.54Zm-9.74,2.82h-2.08v1.97h2.08v-1.97Zm-56.4-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-32.6,8.2h-2.08v1.97h2.08v-1.97Zm-61.38,4.3c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.34,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.55-11.05l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.59-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-7.06-5.18h-7.6v1.32h7.6v-1.32Zm0-3.16h-7.6v1.32h7.6v-1.32Zm-11.66,4.04h-2.08v1.97h2.08v-1.97Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m346.49,299.41c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.92.4-1.08.61-2.19.61-3.33s-.2-2.28-.61-3.35c-.41-1.08-.99-2.05-1.75-2.91h-.95Zm-41.5,8.2h-2.08v1.97h2.08v-1.97Zm-34.68,4.3c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.82-9.91h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-97.9,0h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-9.88,2.7l.4-1.97v-2.18h-1.45v2.18l.4,1.97h.65Zm-69.57,8.35c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.25-1.49-.25-2.21s.08-1.47.25-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-7.15-1.51h-7.42v1.13h7.42v-1.13Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m340.59,289.81h-2.08v1.97h2.08v-1.97Zm-8.63-6.75l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-12.16-1.45c.36.56.67,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.24,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53l-.02.04,1.54,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88s-.5-1.41-.66-2.17c-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21.39-1.46.67-2.15c.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.4,1.08.99,2.05,1.75,2.91h.95Zm-9.82-9.91h-2.08v1.97h2.08v-1.97Zm0,5.61h-2.08v1.97h2.08v-1.97Zm-8.9,0h-2.08v1.97h2.08v-1.97Zm-133.5,0h-2.08v1.97h2.08v-1.97Zm-11.9-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-49.48,12.51c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m307.66,274.8h-7.42v1.13h7.42v-1.13Zm-180.67-2.79h-2.08v1.97h2.08v-1.97Zm-11.9-8.2c.36.56.68,1.19.96,1.88.28.69.5,1.41.66,2.16.16.75.24,1.49.24,2.22s-.08,1.46-.25,2.2c-.16.75-.38,1.46-.66,2.15-.28.69-.59,1.32-.95,1.89h.95c.76-.86,1.35-1.83,1.75-2.91.41-1.08.61-2.19.61-3.33s-.2-2.27-.61-3.35c-.4-1.08-.99-2.05-1.75-2.91h-.95Zm-23.44,1.45l-1.17-2.54h-1.53v.04s1.53,2.49,1.53,2.49h1.17Zm-8.25,11.05c-.36-.56-.67-1.19-.95-1.88-.28-.69-.5-1.41-.66-2.17-.16-.75-.24-1.49-.24-2.21s.08-1.47.24-2.21c.16-.74.39-1.46.67-2.15.28-.69.6-1.32.94-1.88h-.95c-.76.86-1.35,1.83-1.75,2.91-.41,1.08-.61,2.19-.61,3.34s.2,2.27.61,3.35c.41,1.08.99,2.05,1.75,2.91h.95Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 104.44,
    y: 257,
    width: 7.42,
    height: 1.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesafeli);
export default __webpack_public_path__ + "static/media/mesafeli.50f1685edcbc9117b36e0a1211a6cd6b.svg";
export { ForwardRef as ReactComponent };